import {getConsignmentsForUser} from '../src';
import {ref, type Ref} from 'vue';
import {getFromLocalStorage, saveToLocalStorage} from '../../availability/src/utils/local.storage.utils';

const CONSIGNMENTS_LOCAL_STORAGE_KEY = 'consignments';

export function useConsignments() {
	const consignments: Ref<string[]> = ref([]);

	const loadConsignmentsFromLocalStorage = () => {
		const storedConsignments = getFromLocalStorage(CONSIGNMENTS_LOCAL_STORAGE_KEY) as string[] | null;
		consignments.value = storedConsignments && Array.isArray(storedConsignments) ? storedConsignments : [];
	};

	const persistConsignments = () => {
		saveToLocalStorage(CONSIGNMENTS_LOCAL_STORAGE_KEY, consignments.value);
	};

	const setConsignments = (newConsignments: string[]) => {
		loadConsignmentsFromLocalStorage();
		consignments.value = newConsignments;
		persistConsignments();
	};

	const addConsignment = (consignment: string) => {
		loadConsignmentsFromLocalStorage();
		consignments.value.unshift(consignment);
		persistConsignments();
	};

	const removeConsignment = (consignment: string) => {
		loadConsignmentsFromLocalStorage();
		consignments.value = consignments.value.filter(c => c !== consignment);
		persistConsignments();
	};

	const moveConsignmentToTop = (consignment: string) => {
		loadConsignmentsFromLocalStorage();
		consignments.value = [
			consignment,
			...consignments.value.filter(c => c !== consignment)
		];
		persistConsignments();
	};

	const initConsignments = async () => {
		loadConsignmentsFromLocalStorage();
		if (consignments.value.length > 0) {
			return;
		}
		try {
			consignments.value = await getConsignmentsForUser();
			persistConsignments();
		} catch (error) {
			console.error('Error initializing consignments:', error);
		}
	};

	return {
		consignments,
		setConsignments,
		addConsignment,
		removeConsignment,
		moveConsignmentToTop,
		initConsignments
	};
}
